import { captureException } from '@sentry/react'
import { createRootRoute, Navigate, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { ApiError } from '@/lib/api'
import { ForbiddenPage } from '@/pages/ForbiddenPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { UnexpectedErrorPage } from '@/pages/UnexpectedErrorPage'

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />,
  errorComponent: ({ error }) => {
    const isApiError = error instanceof ApiError
    if (isApiError && error.status === 401) {
      return (
        <Navigate
          to="/login"
          search={{
            redirectTo: window.location.pathname + window.location.search,
          }}
          reloadDocument
        />
      )
    }
    if (isApiError && error.status === 403) {
      return <ForbiddenPage />
    }
    if (isApiError && error.status === 404) {
      return <NotFoundPage />
    }

    // 500系エラーをSentryに送信
    captureException(error, {
      level: 'fatal',
      tags: {
        type: 'errorComponent',
        route: window.location.pathname + window.location.search,
      },
    })
    return <UnexpectedErrorPage />
  },
})

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-left" />}
    </>
  )
}
